/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2DoubleArrowLeft/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2DoubleArrowLeft({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2DoubleArrowLeft",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2DoubleArrowLeft.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 10"
 style={{'--as-1-21sClL': alignSelf,'--mt-2-21sClL': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-21sClL': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-21sClL': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-21sClL': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-21sClL': opacity,'--w-10-21sClL': typeof width === 'number' ? `${width}px` : width,'--h-11-21sClL': typeof height === 'number' ? `${height}px` : height,'--f-12-21sClL': fill,'--a-7-21sClL': isAnimated ? animation : "none",'--sd-8-21sClL': isAnimated ? strokeDashoffset : 0,'--sd-9-21sClL': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2DoubleArrowLeft.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2176_3982)"
 className="views-block"
>
<path
  data-testid="Tysiav2DoubleArrowLeft.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.994.027c.133.055.22.186.22.33v2.71L9.176.104a.357.357 0 01.61.252v9.286a.357.357 0 01-.61.252L6.214 6.934v2.709a.357.357 0 01-.61.252l-4.382-4.39a.7.7 0 010-1.01L5.604.104a.357.357 0 01.39-.078z"
 style={{'--f-12-21sClL': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}